<template>
    <v-card flat>
        <v-card-title>
            <Button
                    width="248"
                    depressed
                    v-on:onClick="openCreateClient"
                    class="my-3"
                    content="+ ADD CLIENT"
            />
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="headers"
                :items="clientsData"
                :loading="loading"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @update:sort-desc="handleSortDesc"
                hide-default-footer
        >
            <template v-slot:item.limits="{ item }">
                <div v-for="(n, index) in item.limits"
                     :key="index">
                    {{n.resource.display_name}} with Limit: {{n.limit_value}}
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="openEditItem(item)"
                        title="Edit client"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="openDeleteClient(item)"
                        title="Delete client"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data> NO DATA </template>
        </v-data-table>
        <v-row class="align-center">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="7"
                        @input="onChangePagination"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 'All']"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                ></v-select>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogCreateClient" max-width="700px" persistent>
            <v-card>
                <v-form
                        ref="create"
                        v-model="valid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">{{ formTitle }}</v-card-title>
                    <v-card-text>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-row><v-col cols="12" class="py-0"><b>Sourcepoint ID:</b></v-col></v-row>
                                    <v-text-field
                                            class="py-0"
                                            v-model="newClient.sp_id"
                                            placeholder="Sourcepoint ID"
                                    ></v-text-field>
                                    <v-row><v-col cols="12" class="py-0"><b>Client name:</b></v-col></v-row>
                                    <v-text-field
                                            class="py-0"
                                            v-model="newClient.name"
                                            placeholder="Client name"
                                            :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
                                    ></v-text-field>
                                    <v-row><v-col cols="12" ><b>Feature Access:</b></v-col></v-row>
                                    <v-simple-table v-if="newClient.limits.length">
                                        <template>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Resource</th>
                                                    <th class="text-left">Limit</th>
                                                    <th class="text-left">Priority</th>
                                                    <th class="text-left" v-if="newClient.limits.length >1">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(n, index) in newClient.limits" :key="index" style="vertical-align: baseline">
                                                    <td class="align-center">
                                                        <v-autocomplete
                                                                v-model="n.resource"
                                                                :items="resourcesList"
                                                                placeholder="Resource"
                                                                item-value="id"
                                                                item-text="display_name"
                                                                required
                                                                dense
                                                                name="resource"
                                                                :rules="[autocompleteRule]"
                                                                @change="((event) => handleChangeResource(event, index))"
                                                        ></v-autocomplete>
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                                type="number"
                                                                min="0"
                                                                v-model="n.limit_value"
                                                                label="Limit"
                                                                single-line
                                                                @change="handleChangeNumber('limit_value', index)"
                                                                :rules="[numberRule]"
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                                v-model="n.priority"
                                                                label="Priority"
                                                                single-line
                                                                @change="handleChangeNumber('priority', index)"
                                                                :rules="[numberRuleMinMax]"
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <v-icon
                                                                v-if="newClient.limits.length !== 1"
                                                                middle
                                                                title="Delete resource"
                                                                @click="removeResource(index)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row>
                                        <v-col cols="12" align="center" class="py-0">
                                            <v-btn color="primary" text @click="addResource" v-if="!isDisableAddResource">+ Add</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" align="right">
                                    <v-btn color="red darken-1" text @click="closeCreateClient">Cancel</v-btn>
                                    <v-btn color="green darken-1" text @click="saveClient">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteClient" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="delete"
                        v-model="deleteValid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">Confirm delete client</v-card-title>
                    <v-card-text>
                        <div>Please, enter 'Delete {{clientName}}' in the text field to confirm client deletion</div>
                        <v-text-field
                                v-model="confirmDelete"
                                label="Delete ClientName"
                                :rules="[deleteRule]"
                                single-line
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDeleteClient">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteClient">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import Button from "../common/Button";
    import { createNamespacedHelpers } from "vuex";
    const adminDashboardHelper = createNamespacedHelpers("adminDashboard");
    import adminDashboardApi from '../../api/adminDashboard'
    export default {
        components: {Button},
        name: 'ClientsDashboard',
        computed:{
            ...adminDashboardHelper.mapGetters(["getClients", "getResources"]),
            formTitle () {
                return this.editedIndex === -1 ? 'CREATE CLIENT' : 'EDIT CLIENT'
            },
        },
        data () {
            return {
                search: '',
                headers: [
                    { text: 'Id', align: 'start', value: 'id', sortable: false  },
                    { text: 'SP Id', align: 'start', value: 'sp_id', sortable: false  },
                    { text: 'Name', value: 'name' },
                    { text: 'Limits', value: 'limits', sortable: false },
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
                clientsData: [],
                dialogCreateClient: false,
                dialogDeleteClient: false,
                loading: true,
                page: 1,
                pageCount: 1,
                itemsPerPage: 10,
                totalCount: 1,
                sortDesc: true,
                newClient: {
                    name: '',
                    sp_id: null,
                    limits: [
                        {resource: "3386bb9f-8f2e-4050-90a6-74bec932962a", limit_value: 0, priority: 99},
                    ]
                },
                resourcesList: [],
                clientId: '',
                clientName: '',
                editedIndex: -1,
                numberRule: v  => {
                    if (!isNaN(parseFloat(v)) && v >= 0) return true;
                    return 'Number has to be more or equal 0';
                },
                numberRuleMinMax: v  => {
                    if (!isNaN(parseFloat(v)) && v >= 0 && v<=100) return true;
                    return 'Number has to be more or equal 0 and less or equal 100';
                },
                autocompleteRule: v =>{
                    if (v && Object.keys(v).length !== 0) return true;
                    return 'This field is required';
                },
                deleteRule: v =>{
                    if (!(v && Object.keys(v).length !== 0)) {
                        return 'This field is required';
                    } else if(!(v && this.confirmDelete.includes(`Delete ${this.clientName}`))){
                        return 'The confirmation message must meet the requirements';
                    } return true;
                },
                confirmDelete: '',
                valid: true,
                deleteValid: true,
                isDisableAddResource: true,
                generalResourceId: "3386bb9f-8f2e-4050-90a6-74bec932962a",
                generalResourceObj: {id: "3386bb9f-8f2e-4050-90a6-74bec932962a", name: "general", display_name: "All Non-Admin Access"}
            }
        },
        methods: {
            ...adminDashboardHelper.mapActions([ "fetchClients", "fetchResources" ]),
            getResourcesData(){
                this.fetchResources();
            },
            async getClientsDashboard(){
                this.loading = true;
                await this.fetchClients({
                    page: this.page,
                    page_size: this.itemsPerPage < 0 ? this.pageCount : this.itemsPerPage,
                    sort: this.sortDesc ? 1 : 0,
                    s: this.search
                });
                this.loading = false;
            },
            openCreateClient(){
                this.editedIndex = -1;
                if(this.resourcesList[0].id !== this.generalResourceId){
                    this.resourcesList.unshift(this.generalResourceObj);
                }
                this.newClient.limits[0].resource === this.generalResourceId ?
                    this.isDisableAddResource = true : this.isDisableAddResource = false;
                this.dialogCreateClient = true;
            },
            closeCreateClient () {
                this.dialogCreateClient = false;
                this.newClient = {
                    name: '',
                    sp_id: null,
                    limits: [
                        {resource: this.generalResourceId, limit_value: 0, priority: 99},
                    ]
                };
                this.$refs.create.resetValidation();
            },
            async saveClient(){
                if(this.$refs.create.validate()){
                    if(this.editedIndex > -1){
                        try{
                            await adminDashboardApi.editClient(this.newClient);
                            this.closeCreateClient();
                            this.getClientsDashboard();
                        }catch(err){
                            if(err.response && err.response.status === 400){
                                alert(err.response.data.detail + '. Status: ' + err.response.status)
                            } else {
                                alert(err.response ? (err.response.status === 422 ? err.response.data.detail[0].msg : err.response.data ) : err)
                            }
                        }
                    } else {
                        try{
                            await adminDashboardApi.createClient(this.newClient);
                            this.closeCreateClient();
                            this.getClientsDashboard();
                        }catch(err){
                            if(err.response && err.response.status === 400){
                                alert(err.response.data.detail + '. Status: ' + err.response.status)
                            } else {
                                alert(err.response ? (err.response.status === 422 ? err.response.data.detail[0].msg : err.response.data ) : err)
                            }
                        }
                    }
                }

            },
            openDeleteClient(client){
                this.clientId = client.id;
                this.clientName = client.name;
                this.dialogDeleteClient = true
            },
            closeDeleteClient(){
                this.dialogDeleteClient = false;
                this.confirmDelete = '';
                this.$refs.delete.resetValidation();
            },
            async deleteClient(){
                if(this.$refs.delete.validate()){
                    if(this.confirmDelete.includes(`Delete ${this.clientName}`)){
                        try{
                            await adminDashboardApi.deleteClient(this.clientId);
                            this.closeDeleteClient();
                            this.getClientsDashboard();
                        }catch(err){
                            alert(err)
                        }
                    }
                }
            },
            openEditItem(client){
                this.clientId = client.id;
                this.editedIndex = this.clientsData.indexOf(client);
                let limits = [];
                client.limits.forEach(c=>{
                    limits.push({
                        id: c.id,
                        limit_value: c.limit_value,
                        priority: c.priority,
                        resource: c.resource.id
                    });
                });
                this.newClient = Object.assign({}, {id: client.id, name: client.name, limits: limits, sp_id: client.sp_id});
                if(this.newClient.limits.length && this.newClient.limits[0].resource === this.generalResourceId){
                    this.isDisableAddResource = true;
                } else {
                    this.isDisableAddResource = false;
                }
                if(this.newClient.limits.length < 2){
                    if(this.resourcesList[0].id !== this.generalResourceId){
                        this.resourcesList.unshift(this.generalResourceObj)
                    }
                }
                this.dialogCreateClient = true;
            },
            handleItemsPerPage(itemsPerPage){
                this.page = 1;
                if(itemsPerPage === 'All'){
                    this.itemsPerPage = this.totalCount;
                } else {
                    this.itemsPerPage = itemsPerPage;
                }
                this.getClientsDashboard();
            },
            handleSortDesc(desc){
                if( this.sortDesc !== desc[0] && desc.length){
                    this.sortDesc = desc[0];
                    this.getClientsDashboard();
                }
            },
            addResource(){
                if(this.newClient.limits.length){
                    this.resourcesList.forEach((r, index)=>{
                        if(r.id === this.generalResourceId){
                            this.resourcesList.splice(index, 1)
                        }
                    });
                    this.newClient.limits.push({resource: this.resourcesList[0].id, limit_value: 0, priority: 99});
                } else {
                    this.newClient.limits.push({resource: this.generalResourceId, limit_value: 0, priority: 99});
                }
                this.newClient.limits[0].resource === this.generalResourceId ?
                    this.isDisableAddResource = true : this.isDisableAddResource = false;
            },
            removeResource(index){
                if(this.newClient.limits.length !== 1){
                    this.newClient.limits.splice(index, 1)
                }
                if(this.newClient.limits.length === 1){
                    this.resourcesList.unshift(this.generalResourceObj)
                }
            },
            handleChangeNumber(field, index){
                this.newClient.limits[index][field] = Number(this.newClient.limits[index][field]);
            },
            handleChangeResource(e){
                if(e === this.generalResourceId){
                    this.isDisableAddResource = true
                } else {
                    this.isDisableAddResource = false
                }
            },
            onChangePagination(){
                this.getClientsDashboard();
            }
        },
        created () {
            this.getClientsDashboard();
            this.getResourcesData();
        },
        watch: {
            getClients: function(e){
                this.clientsData = e.results;
                this.pageCount = Math.ceil(e.count/this.itemsPerPage);
                this.totalCount = e.count;
            },
            search: function(){
                this.page = 1;
                this.getClientsDashboard();
            },
            getResources: function(resources){
                resources.forEach(r=>{
                    !r.name.includes('admin') && this.resourcesList.push(r);
                })
            }
        }
    }
</script>
